export function forSetCodes<T>(setCodes: string[], value: T): Record<string, T> {
  return Object.fromEntries(setCodes.map((setCode) => [setCode, value]))
}
